import React from "react"
import { NumericFormat } from "react-number-format"
import { format } from "date-fns"
import { downloadGRNPDF } from "../utils/pdfDownload"
const GRN = ({ receipt }) => {
  const Colour = receipt.vendor.vendor_settings.invoice_color || "#3513f1"
  const name = localStorage.getItem("name")
  const { completed, approved, signatures } = receipt.workflow
  const { phone, email, vendor_name } = receipt.vendor
  console.log(receipt, "GRN RECEIPT")
  // Determine the status, comment, and color
  let status = ""
  let comment = ""
  let statusColor = ""

  if (completed && approved) {
    status = "Approved"
    // comment = signatures.find(sig => sig.role === 'line_manager')?.comment || '';
    statusColor = "text-green-600" // Green for Approved
  } else if (completed && !approved) {
    status = "Declined"
    comment = signatures.find(sig => sig.role === "internal_control")?.comment || ""
    statusColor = "text-red-600" // Red for Declined
  } else {
    status = "Pending"
    statusColor = "text-yellow-600" // Yellow for Pending
  }

  const handleDownload = () => {
    downloadGRNPDF(receipt, Colour)
  }

  return (
    <div className="w-full py-2">
      <div className="flex justify-end mb-2">
        <button
          onClick={handleDownload}
          className="px-4 py-2 text-white text-sm font-semibold rounded hover:opacity-90 transition-opacity"
          style={{ backgroundColor: Colour }}
        >
          Download PDF
        </button>
      </div>
      <div className="flex flex-col md:flex-row  md:justify-between px-1 border-b border-gray-200 pb-4">
        <div className="text-left">
          <p className="font-bold text-xl py-1">RECEIVED AT: </p>
          <p className="text-base text-sm mt-2">
            {receipt?.stores?.map((store, index) => (
              <span key={index}>
                <b style={{ color: Colour }}>
                  {store.store_name} ({store.byd_cost_center_code})
                </b>
                <br />
                {store.store_email}
                {index < receipt.stores.length - 1 && <br />}
              </span>
            ))}
          </p>
        </div>
        <div className="text-right">
          <p className="font-bold text-xl py-1">RECEIVED FROM:</p>
          {receipt?.vendor?.vendor_settings?.logo ? (
            <img
              src={receipt?.vendor?.vendor_settings?.logo}
              alt="vendor logo"
              className="w-32 h-32 my-3 object-contain"
              onError={e => {
                e.target.style.display = "none"
                e.target.nextSibling.style.display = "inline"
              }}
            />
          ) : null}
          <p className="py-1 font-bold" style={{ color: Colour }} display="none">
            {vendor_name || ""}
          </p>
          <p className="text-base text-sm">
            {email && (
              <>
                {email}
                <br />
              </>
            )}
            {phone && (phone.startsWith("+234") ? phone : `+234 (0) ${phone}`)}
          </p>
        </div>
      </div>
      <div className="w-full px-1 mt-4">
        <div>
          <div
            className="border-2 font-normal text-[#545454] flex flex-col"
            style={{ borderColor: Colour }}
          >
            <div className="flex px-2 py-1 m-0">
              <span>
                <b>GRN Date:</b>
              </span>
              <span className="text-right flex-grow ">
                {format(new Date(receipt?.created), "dd-MMM-yyyy")}
              </span>
            </div>
            <div className="flex gap-36 m-0 px-2 py-1">
              <span>
                <b>PO Number:</b>
              </span>
              <span className="flex-grow text-right">{receipt?.purchase_order?.po_id}</span>
            </div>
            <div className="flex gap-36 m-0 px-2 py-1">
              <span>
                <b>GRN Number:</b>
              </span>
              <span className="flex-grow text-right">{receipt?.grn_number}</span>
            </div>

            <div className="mt-2 border-t border-gray-200 pt-2"></div>

            {/* <div className="flex gap-36 m-0 px-2 py-1">
            <span><b>Gross Total (Incl. Tax):</b></span>
            <span className="flex-grow text-right">
              ₦ 
              <NumericFormat
                value={receipt.total_value_received}
                displayType="text"
                thousandSeparator={true}
                decimalSeparator="."
                decimalScale={2}
                fixedDecimalScale
              />
            </span>
          </div>
          <div className="flex gap-36 m-0 px-2 py-1">
            <span><b>Tax Amount:</b></span>
            <span className="flex-grow text-right">
              ₦ 
              <NumericFormat
                value={receipt.total_tax_amount}
                displayType="text"
                thousandSeparator={true}
                decimalSeparator="."
                decimalScale={2}
                fixedDecimalScale
              />
            </span>
          </div>
          <hr className="border-gray-200" /> */}
            <div className="flex gap-36 m-0 p-2 text-lg">
              <span>
                <b>Total Value Received:</b>
              </span>
              <span className="flex-grow text-right">
                ₦
                <NumericFormat
                  value={receipt.invoice.gross_total}
                  displayType="text"
                  thousandSeparator={true}
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="w-full mt-4 border-gray-200 table-auto">
          <thead className="text-white text-xs w-full" style={{ backgroundColor: Colour }}>
            <tr className="text-center">
              <td className="font-semibold px-1 py-3 whitespace-nowrap">SN</td>
              <td className="font-semibold px-2 whitespace-nowrap">Description</td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Unit Price
                <br />
                (₦)
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Ordered
                <br />
                Quantity
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Received
                <br />
                Quantity
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">Discount</td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Gross Total
                <br />
                (₦)
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Tax
                <br />
                (₦)
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Net Total
                <br />
                (₦)
              </td>
            </tr>
          </thead>
          <tbody>
            {receipt.invoice_line_items.map((item, index) => (
              <tr key={index} className="border-b dark:border-gray-700 text-xs text-center">
                <td className="py-2 px-1">{index + 1}</td>
                <td className="px-2 text-left min-w-[120px]">
                  {item.grn_line_item.purchase_order_line_item.product_name}
                </td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={
                      item.po_line_item?.unit_price ||
                      item.grn_line_item?.purchase_order_line_item?.unit_price
                    }
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
                <td className="px-1 whitespace-nowrap">
                  <NumericFormat
                    value={item.grn_line_item?.purchase_order_line_item?.quantity}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                  <br />
                  <span className="text-[10px] text-gray-400">
                    {item.grn_line_item?.purchase_order_line_item?.unit_of_measurement || ""}s
                  </span>
                </td>
                <td className="px-1 whitespace-nowrap">
                  <NumericFormat
                    value={item.grn_line_item.quantity_received}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                  <br />
                  <span className="text-[10px] text-gray-400">
                    {item.grn_line_item?.purchase_order_line_item?.unit_of_measurement || ""}s
                  </span>
                </td>
                <td className="px-1">{item.discount ? item.discount : 0.0}</td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={item.grn_line_item.gross_value_received}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={item.grn_line_item.tax_value}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={item.grn_line_item.net_value_received}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex w-full px-4 items-center">
        <div className="w-full mt-8 text-[#545454]">
          {/* <div className="text-right" style={{ color: Colour }}>
          Gross Total: ₦
          <NumericFormat 
            value={receipt.total_value_received} 
            displayType="text" 
            thousandSeparator={true} 
            decimalSeparator="." 
            decimalScale={2} 
            fixedDecimalScale 
          />
        </div>
        <div className="text-right mt-2" style={{ color: Colour }}>
          Tax Amount: ₦
          <NumericFormat 
            value={receipt.total_tax_amount} 
            displayType="text" 
            thousandSeparator={true} 
            decimalSeparator="." 
            decimalScale={2} 
            fixedDecimalScale 
          />
        </div> */}
          <div className="text-right mt-2 font-bold text-lg" style={{ color: Colour }}>
            Total Value Received: ₦
            <NumericFormat
              value={receipt.invoice.gross_total}
              displayType="text"
              thousandSeparator={true}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default GRN
